module.exports = __webpack_public_path__ + "img/20180815_150119_059.8e5bd9b8.jpg";